import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import AsyncSelect from 'react-select/async';
import NumberFormat from 'react-number-format';

export default class BankTransaction extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            redirect: null,
        };
    }

    componentDidMount() {
        this.httpPost("api/v1/banktransaction/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    save(e) {
        e.preventDefault();

        const record = this.state.data.record;

        // تبدیل مقادیر به عدد
        const companyId = parseInt(record.companyId, 10);
        const id = parseInt(record.id, 10);
        const amount = parseFloat(record.amount);
        const transactionType = parseInt(record.transactionType, 10);
        const operationId = parseInt(record.operationId, 10);
        const bankId = parseInt(record.bankId, 10);

        // تبدیل زمان و تاریخ به رشته‌های قابل قبول
        const transactionDate = new Date(record.transactionDate).toISOString();
        const transactionTime = record.transactionTime;

        this.httpPost("api/v1/banktransaction/save", {
            id: id,
            companyId: companyId,
            transactionNumber: record.transactionNumber,
            transactionDate: transactionDate,
            transactionTime: transactionTime,
            amount: amount,
            description: record.description,
            bankDescription: record.bankDescription,
            transactionType: transactionType,
            operationId: operationId,
            bankId: bankId
        })
            .then(data => {
                if (data.status === -1) {
                    window.location.href = "/login";
                } else if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/banktransactions'
                    });
                } else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }

    setType(type) {
        this.state.data.record.transactionType = type;
        this.setState({ data: this.state.data });
    }

    handleSelectChange = (selectedOption) => {
        this.state.data.record.accountId = selectedOption.id; // تنظیم accountId
        this.setState({ data: this.state.data });
    }

    loadOperationOptions = (inputValue, callback) => {
        this.httpPost("api/v1/operation/list", { phrase: inputValue, page: 1, count: 10 })
            .then(data => {
                if (data.status === 1) {
                    const options = data.records.map(operation => ({
                        value: operation.id,
                        label: operation.name
                    }));
                    callback(options);
                }
            });
    }

    loadBankOptions = (inputValue, callback) => {
        this.httpPost("api/v1/bank/list", { phrase: inputValue, page: 1, count: 10 })
            .then(data => {
                if (data.status === 1) {
                    const options = data.records.map(bank => ({
                        value: bank.id,
                        label: bank.name
                    }));
                    callback(options);
                }
            });
    }

    renderForm() {
        console.log(this.state)
        return (
            <div className="nk-content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="components-preview wide-md mx-auto">
                                <div className="nk-block-head nk-block-head-lg wide-sm">
                                    <div className="nk-block-head-content">
                                        <div className="nk-block-head-sub">
                                            <a className="back-to" to="/banktransactions/">
                                                <em className="icon ni ni-arrow-left" />
                                                <span>فهرست تراکنش‌ها</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="nk-block nk-block-lg">
                                    <div className="card card-bordered">
                                        <div className="card-inner">
                                            <div className="card-head">
                                                <h5 className="card-title">اطلاعات تراکنش</h5>
                                            </div>
                                            <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">نوع تراکنش</label>
                                                        <div className="form-control-wrap">
                                                            <select className="form-control" defaultValue={this.state.data.record.transactionType} onChange={e => this.setType(parseInt(e.target.value))}>
                                                                <option value={0}>دریافت</option>
                                                                <option value={1}>پرداخت</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">نام عملیات</label>
                                                        <div className="form-control-wrap">
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.loadOperationOptions}
                                                                defaultValue={!this.isNull(this.state.data.record.operationId) ? {
                                                                    value: this.state.data.record.operationId,
                                                                    label: this.state.data.record.operationName
                                                                } : null}
                                                                defaultOptions
                                                                onChange={selectedOption => {
                                                                    this.state.data.record.operationId = selectedOption.value;
                                                                    this.setState({ data: this.state.data });
                                                                }}
                                                                placeholder="جستجوی عملیات"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">نام بانک</label>
                                                        <div className="form-control-wrap">
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.loadBankOptions}
                                                                defaultValue={!this.isNull(this.state.data.record.bankId) ? {
                                                                    value: this.state.data.record.bankId,
                                                                    label: this.state.data.record.bankName
                                                                } : null}
                                                                defaultOptions
                                                                onChange={selectedOption => {
                                                                    this.state.data.record.bankId = selectedOption.value;
                                                                    this.setState({ data: this.state.data });
                                                                }}
                                                                placeholder="جستجوی بانک"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">شماره تراکنش</label>
                                                        <div className="form-control-wrap">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                defaultValue={this.state.data.record.transactionNumber}
                                                                onChange={e => {
                                                                    this.state.data.record.transactionNumber = e.target.value;
                                                                    this.setState({ data: this.state.data });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">تاریخ تراکنش</label>
                                                        <div className="form-control-wrap">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                defaultValue={this.state.data.record.transactionDate}
                                                                onChange={e => {
                                                                    this.state.data.record.transactionDate = e.target.value;
                                                                    this.setState({ data: this.state.data });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">زمان تراکنش</label>
                                                        <div className="form-control-wrap">
                                                            <input
                                                                className="form-control"
                                                                type="text"
                                                                defaultValue={this.state.data.record.transactionTime}
                                                                onChange={e => {
                                                                    this.state.data.record.transactionTime = e.target.value;
                                                                    this.setState({ data: this.state.data });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">مبلغ</label>
                                                        <div className="form-control-wrap">
                                                            <NumberFormat
                                                                className="form-control"
                                                                defaultValue={this.state.data.record.amount}
                                                                onValueChange={values => {
                                                                    this.state.data.record.amount = parseFloat(values.value);
                                                                    this.setState({ data: this.state.data });
                                                                }}
                                                                thousandSeparator={true}
                                                            />
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">شرح</label>
                                                        <div className="form-control-wrap">
                                                            <textarea
                                                                className="form-control"
                                                                defaultValue={this.state.data.record.description}
                                                                onChange={e => {
                                                                    this.state.data.record.description = e.target.value;
                                                                    this.setState({ data: this.state.data });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-4">
                                                    <div className="form-group">
                                                        <label className="form-label">شرح بانک</label>
                                                        <div className="form-control-wrap">
                                                            <textarea
                                                                className="form-control"
                                                                defaultValue={this.state.data.record.bankDescription}
                                                                onChange={e => {
                                                                    this.state.data.record.bankDescription = e.target.value;
                                                                    this.setState({ data: this.state.data });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="form-group">
                                                        <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}